<template>
  <div>
    <div class="topic-wrapper">
      <div class="topic-inner container-wrapper">
        <div class="primary-title">
          <div class="ch">教育专题</div>
          <div class="en">Education topic</div>
        </div>
        <div class="topic-content" v-for="(item, index) of TopicList" :key="index" @click="handleTopic(item)">
          <!-- <img src="./img/img-1.png"/> -->
          <div class="animation-wrapper">
            <img :src='require(topImgListUrl + (index+1) + ".png")' alt="">
          </div>
          <div>{{item}}</div>
        </div>
      </div>
    </div>
    <div class="area-wrapper" v-if="this.indexArea.length">
      <div class="area-inner container-wrapper">
        <div class="primary-title">
          <div class="ch">地区分类</div>
          <div class="en">Search by region</div>
        </div>
        <div class="area-content-wrapper">
          <div class="area-content" v-for="(item, index) of this.indexArea" :key="index">
            <span class="city-name" @click="handleArea(item.value)">{{item.value}}</span>
            <span class="city-count">{{item.count}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Home',
  data () {
    return {
      topImgListUrl: './img/img-',
      TopicList: ['教育事业', '教育行政', '各类教育', '各级教育', '教学理论', '电化教育', '思想政治教育', '学校管理', '教育工作者与学生', '学校建筑和设备的管理']
    }
  },
  computed: {
    ...mapState(['indexArea'])
  },
  mounted () {
    this.$store.dispatch('getIndexAreaCategory', {core: 'LocalChronicleEdu', facetPivot: ['Province']})
  },
  methods: {
    async handleTopic(item) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({ path: 'entry', query: { CategoryA: item } })
      }
    },
    async handleArea(item) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({ path: 'book', query: { Province: item } })
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .primary-title {
    box-sizing: border-box;
    padding-top: 50px;
    .ch {
      width:128px;
      font-size:30px;
      font-family:Source Han Sans SC;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:36px;
      margin: 0 auto;
      text-align: center;
    }
    .en {
      width:175px;
      font-size:18px;
      font-family:Source Han Sans SC;
      font-weight:300;
      color:rgba(153,153,153,1);
      line-height:35px;
      margin: 0 auto;
      text-align: center;
    }
    &:after {
      display: block;
      content: "";
      width:40px;
      height:4px;
      background:rgba(170,170,170,1);
      border-radius:2px;
      margin: 0 auto;
      text-align: center;
    }
  }
  .topic-wrapper {
    background: url("./img/top-bg.png") no-repeat;
    background-color: #E9EDF0;
    overflow: hidden;
    height: 820px;
    .topic-inner {
      overflow: hidden;
    }
    .animation-wrapper {
      height: 204px;
      width: 204px;
      overflow: hidden;
    }
    .topic-content {
      height: 280px;
      width: 220px;
      background: #ffffff;
      margin: 0 10px;
      float: left;
      text-align: center;
      margin-top: 33px;
      margin-bottom: 11px;
      overflow: hidden;
      box-shadow:0px 2px 6px 0px rgba(120,120,120,0.25);
      &:hover {
        img {
          transform: scale(1.2)
        }
      }
      cursor: pointer;
      img {
        transition: all .5s;
      }
      div {
        font-size:20px;
        color:rgba(0,59,131,1);
        line-height:32px;
        text-align: center;
        margin: 7px 8px;
        &:hover {
          color:rgb(2, 115, 252);
        }
      }
    }
  }
  .area-wrapper {
    background: url("./img/area-bg.png") center bottom no-repeat;
    background-size: 100% auto;
    .area-content-wrapper {
      overflow: hidden;
      margin-left: 55px;
    }
    padding-left: 40px;
    overflow: hidden;
    padding-bottom: 74px;
    .area-content {
      float: left;
      margin-top: 40px;
      width: 228px;
      &::before {
        display: inline-block;
        content: '';
        width:5px;
        height:35px;
        background:rgba(23,67,165,1);
        border-radius:3px;
        margin-right: 14px;
        line-height:35px;
        vertical-align: middle;
      }
      .city-name {
        height:35px;
        font-size:16px;
        font-family:Microsoft YaHei;
        font-weight:400;
        color:rgba(0,59,131,1);
        line-height:35px;
        vertical-align: middle;
        margin-right: 30px;
        cursor: pointer;
        &:hover {
          color: rgb(7, 115, 247);
        }
      }
    .city-count {
        height:35px;
        font-size:14px;
        font-family:Arial;
        font-weight:400;
        color:rgba(153,153,153,1);
        line-height:35px;
        vertical-align: middle;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home/Home.vue